import { Component, Input, OnInit } from '@angular/core';

import { AppService, WhitelabelService } from '@app/services';

@Component({
  selector: 'app-auth-container',
  templateUrl: './auth-container.component.html',
  styleUrls: ['./auth-container.component.scss'],
  standalone: false
})
export class AuthContainerComponent implements OnInit {
  @Input() backToRegister = false;

  constructor(
    public whitelabelService: WhitelabelService,
    public appService: AppService
  ) {}

  ngOnInit() {}
}
